import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import { uncontrollable } from 'uncontrollable';
import { TabContainerProvider } from '../bootstrap/context/TabContext';
const TAB = 'tab';
const PANE = 'pane';
class TabContainer extends React.Component {
  render() {
    const {
      children,
      activeKey,
      onSelect,
      generateChildId,
      ...props
    } = this.props;
    const {
      id
    } = props;
    const getId = generateChildId || ((key, type) => id ? `${id}-${type}-${key}` : null);
    const contextValue = {
      activeKey,
      onSelect,
      getTabId: key => getId(key, TAB),
      getPaneId: key => getId(key, PANE)
    };
    return /*#__PURE__*/_jsx(TabContainerProvider, {
      value: contextValue
    }, void 0, /*#__PURE__*/React.cloneElement(React.Children.only(children), props));
  }
}
export default uncontrollable(TabContainer, {
  activeKey: 'onSelect'
});